import * as firebase from "firebase/app";
import iammitest_keys from "./firebase_keys/iammitest.json"
import dev_keys from "./firebase_keys/development.json"
//require('dotenv').config();

function get_keys() {
    if (process.env.REACT_APP_AMBIENT === "production") {
        return iammitest_keys;
    }

    return dev_keys;
}

const firebase_app = firebase.initializeApp(get_keys());

export default firebase;
export { firebase_app };
